import $ from 'jquery';
import validate from 'jquery-validation';
import { toggleItems } from '@src/components/toggleItems';

$(window).on('load', function () {
  const $items = $('.footer-main-links-cols.toggle-item');
  toggleItems($items);

  $.validator.addMethod('regex', function (value, element, param) {
    return this.optional(element) ||
      value.match(typeof param === 'string' ? new RegExp(param) : param);
  });

  $('#customerio-form').submit(function (e) {
    e.preventDefault();
  }).validate({
    rules: {
      email: {
        required: true,
        email: true,
        regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      }
    },
    submitHandler: function (form) {
      submitForm(form);
    }
  });

  $('#customerio-form #email').on('blur keyup', function () {
    const $newsletterBtn = $('#customerio-form .btn-newsletter');
    if ($('#customerio-form #email').valid()) {
      $newsletterBtn.removeAttr('disabled');
    } else {
      $newsletterBtn.attr('disabled', true);
    }
  });

  function submitForm(form) {
    const emailToAdd = $('#customerio-form #email').val();
    const authenticityToken = $('#customerio-form input[name="authenticity_token"]').val();
    const previousUrl = $('#previous-url').val();
    trackForm(form);

    $.post(
      hostUrl.trim() + 'newsletter/add',
      {
        email: emailToAdd,
        anonymous_id: getAnonymousId(),
        authenticity_token: authenticityToken,
        previous_url: previousUrl
      }
    ).done(function (data) {
      $('#customerio-form .btn-newsletter').attr('disabled', true);
      $('#customerio-form .customerio-form-btn').addClass('icon-checkmark');
    });
  }

  function trackForm(form) {
    const dataLocation = $('#customerio-form .btn-newsletter').attr('data-location');
    window.analytics.track('website_front_newsletter_submitted', {
      page_url: window.location.href,
      command: 'form_newsletter',
      category: 'Navigation',
      action: 'Newsletter Subscription',
      label: dataLocation,
      location: dataLocation,
      url: window.location.href,
    });
  }

  const langLinks = document.querySelectorAll('.footer-lang-switch-button');
  const langDropdowns = document.querySelectorAll('.footer-lang-switch-dropdown');

  for (const [index, langLink] of langLinks.entries()) {
    langLink.addEventListener('click', function () {
      this.focus();
      langDropdowns[index].classList.toggle('open');
      langDropdowns[index].focus();
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.footer-lang-switch-button')) return;
      langDropdowns[index].classList.remove('open');
    });
  }

  const footerLegalMention = document.querySelector('.footer-legal-mention');
  footerLegalMention.innerHTML = "<span itemprop='termsOfService'>"+footerLegalMention.innerHTML+"</span>";
});
